import { mqMin } from '../../breakpoints';

const base = {
  caseStudy: {
    '& .reactSelectDropdown__control': {
      border: 0,
      borderRadius: 0,
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: 'coolGrey.40',
      '&:hover, &--is-focused': {
        borderColor: 'coolGrey.40',
        boxShadow: 'none',
        outline: 'auto',
      },
      '&--is-focused': {
        svg: {
          outline: 'auto',
        },
      },
    },
    '& .reactSelectDropdown__placeholder, & .reactSelectDropdown__indicator': {
      color: 'coolGrey.60',
    },
    '& .reactSelectDropdown__indicator-separator': {
      width: 0,
    },
    '& .reactSelectDropdown__menu': {
      margin: 0,
      borderRadius: 0,
      backgroundColor: 'coolGrey.80',
      zIndex: 'z500',
    },
    '& .reactSelectDropdown__menu-list': {
      padding: 's4',
      display: 'flex',
      flexFlow: 'row wrap',
    },
    '& .reactSelectDropdown__option': {
      cursor: 'pointer',
      color: 'white',
      flex: '0 1 100%',
      fontSize: 'fs12',
      [mqMin.mobile]: {
        flex: '0 1 50%',
      },
      '&:hover, &:active, &--is-selected': {
        textDecoration: 'underline',
        background: 'transparent',
        outline: 'none',
      },
      '&--is-focused': {
        outline: 'auto',
        background: 'transparent',
      },
    },
  },
  default: {
    '& .reactSelectDropdown__placeholder, & .reactSelectDropdown__indicator': {
      color: 'coolGrey.60',
    },
    '& .reactSelectDropdown__control': {
      borderColor: 'coolGrey.40',
    },
  },
  form: {
    '& .reactSelectDropdown__placeholder, & .reactSelectDropdown__indicator': {
      color: 'coolGrey.100',
    },
    '& .reactSelectDropdown__indicator-separator': {
      display: 'none',
    },
    '& .reactSelectDropdown__control': {
      borderRadius: 'form',
      borderColor: 'coolGrey.80',
      borderWidth: '1px',
      borderStyle: 'solid',
      boxShadow: 'none',
      height: '50px',
      '&:hover': {
        borderColor: 'coolGrey.100',
      },
      '&--is-focused': {
        borderColor: 'coolGrey.100',
        borderWidth: '2px',
        borderStyle: 'solid',
      },
    },
    '& .reactSelectDropdown__menu': {
      backgroundColor: 'coolGrey.5',
    },
    '& .reactSelectDropdown__option': {
      color: 'label',
      fontSize: 'S',
      fontWeight: 'regular',
      lineHeight: 'label',
      marginTop: 0,
      '&--is-focused, &:active': {
        backgroundColor: 'coolGrey.100',
        color: 'white',
      },
      '&--is-selected': {
        backgroundColor: 'coolGrey.70',
        color: 'white',
      },
    },
  },
  product: {
    borderBottomWidth: '4px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'coolGrey.100',
    marginBottom: 's32',
    width: '100%',
    [mqMin.tablet]: {
      minWidth: '240px',
      width: 'auto',
    },
    '& .reactSelectDropdown__menu': {
      zIndex: 'z500',
    },
    '& .reactSelectDropdown__option': {
      cursor: 'pointer',
    },
    '& .reactSelectDropdown__control': {
      border: 'none',
      boxShadow: 'none',
      '&--is-focused': {
        outline: 'auto !important',
      },
    },
    '& .reactSelectDropdown__placeholder': {
      color: 'coolGrey.60',
    },
    '& .reactSelectDropdown__indicator': {
      color: 'coolGrey.100',
      '&-separator': {
        backgroundColor: 'transparent',
      },
    },
  },
  sort: {
    width: '100%',
    zIndex: 'z100',
    minWidth: '140px',
    '& .reactSelectDropdown__control': {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.60',
      padding: 's4',
      '&--is-focused': {
        svg: {
          outline: 'auto',
        },
      },
    },
    '& .reactSelectDropdown__placeholder': {
      color: 'coolGrey.60',
    },
    '& .reactSelectDropdown__indicator': {
      color: 'coolGrey.100',
      '&-separator': {
        backgroundColor: 'transparent',
      },
    },
    '& .reactSelectDropdown__option': {
      '&--is-focused': {
        outline: 'auto',
        outlineOffset: '-1px',
        background: 'transparent',
      },
      '&--is-selected': {
        color: 'coolGrey.100',
        background: 'transparent',
      },
    },
  },
  search: {
    width: '100%',
    zIndex: 'z100',
    minWidth: '140px',
    '& .reactSelectDropdown__menu': {
      backgroundColor: 'coolGrey.0',
      padding: 's16',
    },
    '& .reactSelectDropdown__control': {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.80',
      padding: 's4',
      borderRadius: '2px',
      '&:hover': {
        borderColor: 'coolGrey.100',
      },
      '&--is-focused': {
        boxShadow: '0 0 0 1px #282C33',
        borderColor: 'coolGrey.100',
        svg: {
          outline: 'auto',
        },
        '.iconMagnifyingGlass': {
          svg: {
            outline: 'none',
          },
        },
      },
    },
    '& .reactSelectDropdown__value-container': {
      '&:hover': {
        cursor: 'text',
      },
    },
    '& .reactSelectDropdown__placeholder': {
      color: 'coolGrey.60',
    },
    '& .reactSelectDropdown__indicator': {
      color: 'coolGrey.100',
      '&-separator': {
        backgroundColor: 'transparent',
      },
    },
    '& .reactSelectDropdown__option': {
      color: 'coolGrey.100',
      fontSize: 'fs16',
      borderRadius: '2px',
      '&:focus, &--is-focused, &:hover': {
        boxShadow: '0 0 0 1px black inset',
        background: 'transparent',
        color: 'coolGrey.100',
      },
      '&--is-selected': {
        backgroundColor: 'blue.10',
        color: 'coolGrey.100',
      },
    },
  },
};

export type FormDropdownVariantsType = 'caseStudy' | 'default' | 'form' | 'product' | 'sort' | 'search';
export const formDropdownVariants = Object.keys(base) as FormDropdownVariantsType[];

const dropdown = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base,
  },
};

export default dropdown;
